import React, {createContext, useContext} from "react";

export const EventContext = createContext(null);

export const EventProvider = ({event, children}) => {
    const context = {event};

    return (
        <EventContext.Provider value={context}>
            {children}
        </EventContext.Provider>
    );
}

export const useEventContext = () => useContext(EventContext);
